export default __webpack_public_path__ + "static/media/about_bg.18c70fe4.jpg";